import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useToasts } from 'react-toast-notifications';
import { useHistory } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import ClipLoader from "react-spinners/ClipLoader";
import { Grid } from "@material-ui/core";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import ModalInconsistencias from "components/ModalInconsistencias";

import api from "../../services/api";
import format from "../../services/Format";
import 'react-confirm-alert/src/react-confirm-alert.css';

import moment from 'moment-timezone';
import 'moment/locale/pt-br';
moment.locale('pt-br');

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },

  cardTitleWhite: {
    height: 'auto',
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '20px',
    marginTop: '5px',
    marginBottom: '5px',
    textAlign: 'center'
  },

  container: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px'
  },

  company: {
    height: 'auto',
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    lineHeight: '15px'
  },

  companyCNPJ: {
    height: 'auto',
    color: '#828282',
    fontSize: '12px',
    textAlign: 'center',
    lineHeight: '5px',
    marginBottom: '30px'
  },

  hora: {
    color: '#1989FF',
    fontSize: '46px',
    lineHeight: '38px',
    textAlign: 'center',
    fontWeight: '600',
    marginTop: '25px'
  },

  dayInfo: {
    color: '#828282',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center'
  },

  infoRegistros: {
    color: '#828282',
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '22px'
  },

  button: {
    borderRadius: '100px !important',
    backgroundLinearGradient: '180deg, #F5F6FB 0%, #E4E7EE 100%',
    backgroundColor: '#f8f9fd',
    color: '#1989FF',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '19px',
    textAlign: 'center',
    border: '7px solid',
    borderColor: '#d8d8d8 !important',
    textTransform: 'none',
    marginBottom: '-3px !important'
  },

  register: {
    color: '#828282',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    height: '12px'
  },

  registerOk: {
    color: '#828282',
    height: '10px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700'
  },

  map: {
    padding: ' 0px 0px !important'
  },

  footer: {
    justifyContent: 'center',
    alignItems: 'baseline',
    display: 'grid',
    padding: '0px !important',
  },

  divRegister: {
    height: '29px'
  },

  gridItem: {
    alignItems: 'center'
  },

  grid: {
    height: '100%'
  },

  containerGrid: {
    position: 'fixed',
    justifyContent: 'center',
    height: '100vh',
    marginTop: '-70px !important',
    alignItems: 'center'
  },

  text: {
    textAlign: 'center',
    color: '#1989ff',
    fontFamily: "Open Sans",
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '42px'
  }
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();
  const history = useHistory();
  const { addToast } = useToasts();
  const [usuario, setUsuario] = useState(null);
  const [hora, setHora] = useState(moment().format('HH:mm:ss'));
  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [dadosBatida, setDadosBatida] = React.useState({});
  const [dia] = useState(moment().format('dddd'));
  const [diaNumero] = useState(moment().format('DD'));
  const [mes] = useState(moment().format('MMMM'));
  const [ano] = useState(moment().format('YYYY'));
  const [registrado, setRegistrado] = React.useState(false)

  setInterval(() => {
    setHora(moment().tz(moment.tz.guess()).format('HH:mm:ss'));
  }, 1000);

  useEffect(() => {
    (async () => {
      try {
        let usuario = await api.getUsuario();        
        if (usuario.success) {
          if ((usuario.data.sisRegPonto == 1) || (usuario.data.sisRegPonto == 4)) {
            history.push("/restrito")            
          }
          else
          if (!usuario.data.aceitouLgpd) {
            history.push("/lgpd");
          }
          else
          if (usuario.data.trocarSenha) {
            history.push("/trocasenha");
          }
          else if (!usuario.data.email || !usuario.data.dtNascim) {
            history.push("/confirmadados");
          }
          
          setUsuario(usuario.data);
          setLoading(false);
        } else {
          setLoading(false);
          if (usuario.statusCode === 401) {
            localStorage.clear();
            history.push("/");
            addToast(usuario.message, { appearance: 'error' });
          } else {
            addToast(usuario.message, { appearance: 'error' });
          }
        }
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
          addToast(err.message, { appearance: 'error' });
        } else {
          addToast(err.message, { appearance: 'error' });
        }
      }
    })();
  }, []);

  const getTitle = () => {
    return (
      <div>
        <i className="icon-touchpad-finger" style={{ fontSize: '52px', color: '#FFFFFF', marginBottom: 60 }} />
        <h5 style={{ marginTop: 30 }}>{'Confirmar Registro?'}</h5>
      </div>
    )
  }

  const getMessage = (dataHoraServidor) => {
    return (
      <h3 style={{ marginBottom: 30 }}>{`Razão Social: ${usuario.razaoSocial}\nHorário: ${dataHoraServidor.data.hora}`}</h3>
    )
  }

  const getIconeSituacao = (tipo) => {
    if (tipo === 'FERIAS') return 'icon-beach-palm-water';
    if (tipo === 'MATERNIDADE') return 'icon-baby-trolley';
    if (tipo === 'AFASTAMENTO') return 'icon-school-teacher-wrong';
    if (tipo === 'RESCISAO') return 'icon-single-man-briefcase';
    if (tipo === 'AUXDOENCA') return 'icon-smiley-nose-blow-1';
    if (tipo === 'ACIDTRABALHO') return 'icon-bandage-shoulder';
    else return 'icon-calendar-favorite';
  }

  const verificaFeriadosSituacoes = async () => {
    if (disabled) return;
    setLoading(true);
    let timezone = moment.tz.guess();
    let dataHoraServidor = await api.dataHoraServidor(timezone);
    let situacoes = await api.getSituacoes(dataHoraServidor.data.data);
    let feriados = await api.getFeriados(dataHoraServidor.data.data);

    let feriado = feriados?.data?.find(objSituacao => objSituacao.dtFeriadoFormatado === dataHoraServidor.data.data);
    let situacao = situacoes?.data?.find(objSituacao => objSituacao.data === dataHoraServidor.data.data);
    situacao = situacao?.situacao?.tipo !== 'ATIVO' ? situacao : undefined;

    if (situacao.situacao) {
      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        title: (
          <div>
            <i className={getIconeSituacao(situacao?.situacao?.tipo)} style={{ fontSize: '52px', color: '#FFFFFF', marginBottom: 60 }} />
            <h5 style={{ marginTop: 30 }}>{'Atenção!'}</h5>
          </div>
        ),
        message: (
          <h3 style={{ marginBottom: 30 }}>{`Identificamos que você está em situação de ${situacao?.situacao?.descricao}.. Deseja continuar?`}</h3>
        ),
        buttons: [
          {
            label: 'Sim, Continuar!',
            onClick: async () => {
              registrar();
            }
          },
          {
            label: 'Não',
            onClick: () => {
              setLoading(false);
              setDisabled(false);
              setRegistrado(false);
            }
          }
        ]
      });
    }
    else if (feriado) {
      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        title: (
          <div>
            <i className='icon-calendar-favorite' style={{ fontSize: '52px', color: '#FFFFFF', marginBottom: 60 }} />
            <h5 style={{ marginTop: 30 }}>{'Atenção!'}</h5>
          </div>
        ),
        message: (
          <h3 style={{ marginBottom: 30 }}>{`Identificamos que hoje é feriado ${feriado?.descricao}.. Deseja continuar?`}</h3>
        ),
        buttons: [
          {
            label: 'Sim, Continuar!',
            onClick: async () => {
              registrar();
            }
          },
          {
            label: 'Não',
            onClick: () => {
              setLoading(false);
              setDisabled(false);
              setRegistrado(false);
            }
          }
        ]
      });
    }
    else {
      registrar();
    }
  }

  const registrar = async () => {
    if (disabled) return;
    try {
      setLoading(true);
      let timezone = moment.tz.guess();
      let dataHoraServidor = await api.dataHoraServidor(timezone);

      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        title: getTitle(),
        message: getMessage(dataHoraServidor),
        buttons: [
          {
            label: 'Sim, Registrar!',
            onClick: async () => {
              try {
                setLoading(true);
                setDisabled(true);
                let batida = await api.registraBatida(dataHoraServidor.data.token);
                let dadosUsuario = await api.getUsuario();
                setUsuario(dadosUsuario.data);
                setDadosBatida(batida.data);
                setLoading(false);
                setDisabled(false);
                setRegistrado(true);
                addToast("Ponto registrado com sucesso!", { appearance: 'success' });
              } catch (err) {
                setLoading(false);
                setDisabled(false);
                if (err.statusCode === 401) {
                  localStorage.clear();
                  history.push("/");
                }
                addToast(err.message, { appearance: 'error' });
              }
            }
          },
          {
            label: 'Não',
            onClick: () => {
              setLoading(false);
              setDisabled(false);
              setRegistrado(false);
            }
          }
        ]
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setDisabled(false);
      if (err.statusCode === 401) {
        localStorage.clear();
        history.push("/");
      }
      addToast(err.message, { appearance: 'error' });
    }
  };

  const fechar = () => {
    setRegistrado(false);
  }

  if (usuario && !registrado) {
    return (
      <div className={classes.gridContainer}>
        <GridContainer style={{ position: 'fixed', justifyContent: 'center', alignItems: 'center', height: '100vh', zIndex: 1 }}>
          <GridItem>
            <Card style={{
              backgroundColor: '#f8f9fd',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              borderColor: '#C8C8C8',
              borderRadius: '25px',
              minHeight: "450px",
              width: '350px',
              textAlign: 'center',
              boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
            }}>
              <CardBody style={{ padding: '0px' }}>
                <GridItem style={{ padding: '0px', marginTop: 20, borderBottom: '1px solid #ddd' }}>
                  <i className="icon-single-neutral" style={{ fontSize: '32px', color: '#1989ff' }} />
                  <h4 className={classes.cardTitleWhite}>{usuario.nome}</h4>
                  <h4 className={classes.company}>{usuario.razaoSocial}</h4>
                  <h4 className={classes.companyCNPJ}>{format.cnpjMask(usuario.cnpj)}</h4>
                </GridItem>

                <GridItem>
                  <h4 className={classes.hora}>{hora}</h4>
                  <h4 className={classes.dayInfo}>{dia}, {diaNumero} {mes} {ano}</h4>
                </GridItem>

                <GridItem style={{ marginTop: 15 }}>
                  <Button onClick={() => verificaFeriadosSituacoes()} style={{ height: "100px", width: "100px" }} className={classes.button} disabled={loading}>Registrar</Button>
                </GridItem>

                <GridItem style={{ marginTop: 25 }}>
                  {usuario.ultimoRegistroData && <h4 className={classes.register}>Último Registro</h4>}
                  {usuario.ultimoRegistroData && <h4 className={classes.dayInfo}>{usuario.ultimoRegistroData ? moment(usuario.ultimoRegistroData?.split("/").reverse().join("-")).format('DD/MM/YYYY') : ''} - {usuario.ultimoRegistro ? usuario.ultimoRegistro : 'ATESTADO'}</h4>}
                </GridItem>
              </CardBody>

              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <ClipLoader
                  size={80}
                  color={"#364e6b"}
                  loading={loading}
                  css={{ border: '8px solid', borderBottomColor: 'transparent' }}
                />
              </div>
            </Card>
          </GridItem>
        </GridContainer>

        <ModalInconsistencias />
      </div>
    );
  } else if (registrado) {
    return (
      <div className={classes.gridContainer}>
        <GridContainer style={{ position: 'fixed', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <GridItem>
            <Card style={{
              backgroundColor: '#f8f9fd',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              borderColor: '#C8C8C8',
              borderRadius: '25px',
              height: "445px",
              width: '350px',
              textAlign: 'center',
              boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
            }}>
              <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #EEEFF4', textAlign: 'center' }}>
                <label className={classes.text}>Ponto Registrado</label>
              </CardHeader>

              <CardBody style={{ padding: '0px' }}>
                <Grid container className={classes.grid}
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  height="100%"
                  justify="center"
                >
                  <GridItem className={classes.gridItem}>
                    <h4 className={classes.registerOk}>Recibo</h4>
                    <h4 className={classes.infoRegistros}>{dadosBatida._id}</h4>

                    <h4 className={classes.registerOk}>CNPJ</h4>
                    <h4 className={classes.infoRegistros}>{format.cnpjMask(usuario.cnpj)}</h4>

                    <h4 className={classes.registerOk}>Razão Social</h4>
                    <h4 className={classes.infoRegistros}>{usuario.razaoSocial}</h4>

                    <h4 className={classes.registerOk}>PIS</h4>
                    <h4 className={classes.infoRegistros}>{usuario.pis}</h4>

                    <h4 className={classes.registerOk}>CPF</h4>
                    <h4 className={classes.infoRegistros}>{format.cpfMask(usuario.cpf)}</h4>

                    <h4 className={classes.registerOk}>Data/Hora</h4>
                    <h4 className={classes.infoRegistros}>{moment(dadosBatida.data).format('DD/MM/YYYY')} - {dadosBatida.hora}</h4>
                  </GridItem>
                </Grid>
              </CardBody>

              <CardFooter className={classes.footer}>
                <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => fechar()} color="primary">Voltar</Button>
              </CardFooter>

              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <ClipLoader
                  size={80}
                  color={"#364e6b"}
                  loading={loading}
                  css={{ border: '8px solid', borderBottomColor: 'transparent' }}
                />
              </div>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
        <ClipLoader
          size={80}
          color={"#364e6b"}
          loading={true}
          css={{ border: '8px solid', borderBottomColor: 'transparent' }}
        />
      </div>
    );
  }
}
